// Model defines the ChatParams as accepted by ABC createChatBot call
export interface ChatParams {
    data: ChatParamsData;
    chatBotState: ChatBotState;
    pageType?: string;
    subPageType?: string;
}

export interface ChatParamsData {
    workflowId: string;
    clientId: string;
    isRVV: boolean;
    conversationHeader: ChatConversationHeader;
}

// Chat bot states
export enum ChatBotState {
    MAXIMIZE = 'MAXIMIZE',
    MINIMIZE = 'MINIMIZE'
}

interface ChatConversationHeader {
    stringId: string;
    defaultValue: string;
}
